import React from "react"
import { Box, Typography, IconButton, Tooltip } from "@mui/material"
import { ChartDialog } from "../../chart-dialog/chart-dialog"
import styles from "./widget-wrapper.module.css"
import Toggle from "../../ui/toggle/toggle"

export default function WidgetWrapper({ 
  title, 
  children, 
  hasInfo = true,
  isTableView = false,
  showBlueDot = false,
  isOn = false,
  setIsOn,
  toogleLables = [],
  isDialogOpen,
  setIsDialogOpen,
  showFilterButton = false,
  isEpandable=true,
  infoText = "",
}) {
  
  return (
    <Box className={`${styles.widgetContainer} ${!isTableView ? styles.graphView : styles.tableView}`}>
      
      {/* Title section */}
      <Box className={`${styles.titleSection}`}>
        <Box className={`${styles.titleGroup} ${isTableView && styles.graphView}`}>
          <Typography className={styles.title}>{title}</Typography>
          {hasInfo && infoText.length ? (
            <Tooltip title={ <div style={{
              color: "black",
              fontSize: "12px",
              maxWidth: "200px"
            }}> {infoText} </div>} >
            <IconButton className={styles.infoButton}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                <path d="M12 16V12M12 8H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              </svg>
            </IconButton>
            </Tooltip>
          ) : null}
        </Box>
        <Box className={styles.actionsContainer}>
          {showBlueDot && setIsOn && (
            <Box className={styles.toggleContainer}>
              <Typography className={styles.toggleLabel}>{toogleLables[0]}</Typography>
              <Toggle isOn={isOn} setIsOn={setIsOn} />
              <Typography className={styles.toggleLabel}>{toogleLables[1]}</Typography>
            </Box>
          )}
          <Box className={styles.buttonGroup}>
            {isEpandable && <ChartDialog
              title={title}
              isOpen={isDialogOpen}
              setIsOpen={setIsDialogOpen}
              trigger={
                <IconButton className={styles.actionButton}>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M3.125 3.12498V6.87498M3.125 3.12498H6.875M3.125 3.12498L7.5 7.49998M3.125 16.875V13.125M3.125 16.875H6.875M3.125 16.875L7.5 12.5M16.875 3.12498H13.125M16.875 3.12498V6.87498M16.875 3.12498L12.5 7.49998M16.875 16.875H13.125M16.875 16.875V13.125M16.875 16.875L12.5 12.5" stroke="#AFB8D5" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </IconButton>
              }
              isTableView={isTableView}
              showFilterButton={showFilterButton}
            >
              {children}
            </ChartDialog>}
            <IconButton className={styles.actionButton}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="5" r="2" fill="currentColor" />
                <circle cx="12" cy="12" r="2" fill="currentColor" />
                <circle cx="12" cy="19" r="2" fill="currentColor" />
              </svg>
            </IconButton>
          </Box>
        </Box>
      </Box>
      
      {/* Content */}
      <Box className={styles.contentContainer}>
        {children}
      </Box>
    </Box>
  )
}